var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-badge',{attrs:{"status":_vm.status,"color":_vm.color,"text":_vm.showText}})
}
var staticRenderFns = []

export { render, staticRenderFns }